import React from 'react';

const money = (value, currency = 'EUR') => {
  const parsed = typeof value === 'string' ? parseFloat(value) : value;
  if (parsed === null || parsed === undefined || !Number.isFinite(parsed)) return '—';
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(parsed);
};

const pct = (value) => {
  const parsed = typeof value === 'string' ? parseFloat(value) : value;
  if (parsed === null || parsed === undefined || !Number.isFinite(parsed)) return '—';
  return `${parsed.toFixed(1)}%`;
};

const INVESTOR_BLUE = 'rgb(37 99 235)';
const FLIPPEX_PINK = 'rgb(215 57 134)';

/**
 * "How ownership works" - how economic interests are split between investors and Flippex.
 * Shared by mobile (bottom sheet) and desktop (modal).
 */
export const OwnershipExplainerContent = ({
  currentNav,
  totalRaise,
  totalShares,
  sharePrice,
  investorPercent,
  flippexPercent,
  flippexValue,
  currency = 'EUR',
}) => (
  <div className="space-y-5 text-sm leading-relaxed text-foreground-muted" data-testid="ownership-explainer-content">
    <div>
      <p className="font-medium text-slate-900 mb-1">1. The asset is valued</p>
      <p>
        At launch the property was valued at {money(currentNav, currency)} (the current property value), based on the
        acquisition price and the capital expenditure budget.
      </p>
    </div>
    <div>
      <p className="font-medium text-slate-900 mb-1">2. Investors fund part of that value</p>
      <p>
        This instrument raises {money(totalRaise, currency)} across {(totalShares || 0).toLocaleString()} shares of{' '}
        {money(sharePrice, currency)} each, which equals{' '}
        <span style={{ color: INVESTOR_BLUE }} className="font-medium">{pct(investorPercent)}</span> of the asset value.
      </p>
    </div>
    <div>
      <p className="font-medium text-slate-900 mb-1">3. Flippex co-invests the remainder</p>
      <p>
        Flippex keeps <span style={{ color: FLIPPEX_PINK }} className="font-medium">{pct(flippexPercent)}</span>{' '}
        ({money(flippexValue, currency)}) of the asset, so we win or lose alongside you.
      </p>
    </div>
    <div>
      <p className="font-medium text-slate-900 mb-1">4. Value changes, ownership does not</p>
      <p>
        When the asset is revalued, every stake changes in value proportionally. Ownership percentages stay exactly the
        same for the life of the investment.
      </p>
    </div>
    <p className="text-xs">
      Capital at risk. Projected returns are estimates and not a guarantee of future performance.
    </p>
  </div>
);

export default OwnershipExplainerContent;
